<template>
    <ProfileOptionSelector :model="'kind'" :nextRoute="() => 'SmokingPage'" />
</template>

<script>
export default {
    name: 'KindsPage',
    mounted() {
        this.$nativeBridge.postMessage({
            action: 'sendFirebaseEvent',
            value: {
                category: 'signUpEvent',
                option: {
                    funnel: this.$route.name,
                    provider: this.$store.getters.payloads.signupData.provider || 'email',
                },
            },
        })
    },
}
</script>
